<template>
	<div class="forgot-password-wrapper">
		<div class="forgot-password-form">
			<form @submit.prevent="">
				<div class="forgot-password-button-wrapper">
					<button @click="back"><i class="fas fa-arrow-left"></i> LOGIN</button>
				</div>
				<img class="login-logo" :src="require('@/assets/logo/New_DeliveryB2B__Branco_Horizontal.png')">
				<div class="forgot-password-text-wrapper">
					<h3>Solicitar redefinição de senha</h3>
				</div>
				<div class="forgot-password-input-wrapper">
					<input ref="username" class="forgot-password-input" type="text" v-model="username" placeholder="Usuário" :disabled="loading" @input="error_msg = ''" />
					<i class="fa fa-fw fa-user forgot-password-input-icon"></i>
				</div>
				<div class="forgot-password-error-wrapper">
					<span class="forgot-password-error" v-if="error_msg != ''"><i class="fas fa-exclamation-circle"></i> {{ error_msg }}</span>
				</div>
				<button class="forgot-password-submit" :disabled="loading" @click.prevent="requestNewPassword">
					<i v-if="!loading" class="fa fa-fw fa-envelope"></i>
					<i v-if="loading" class="fa fa-fw fa-circle-notch fa-spin"></i>
					ENVIAR SOLICITAÇÃO
				</button>
			</form>
		</div>
	</div>
</template>

<script>
import Api from "@/lib/Api";

export default {
	name: "ForgotPassword",

	props: {
		email: {
			type: String,
			require: false,
			default: "",
		},
	},

	data: function() {
		return {
			loading: true,
			username: this.email,
			error_msg: "",
		}
	},

	mounted: function() {
		this.loading = false;
		this.$nextTick(() => {
			this.$refs.username.focus();
		});
	},

	methods: {
		validation: function() {
			let data = {
				username: "",
			};
			this.error_msg = "";

			if (this.username.length == "") {
				this.error_msg = "Insira o e-mail de acesso do usuário.";
				this.$refs.username.focus();
				return false;
			} else {
				data.username = this.username;
			}
			
			return data;
		},

		requestNewPassword: async function() {
			// Valida os dados
			let form = this.validation();
			if (!form) {
				return;
			}
			
			let result = null;
			this.loading = true;
			try {
				result = await Api.post("auth/forgot-password", form);
			} catch(ex) {
				console.log(ex);
				this.error_msg = "Não é possível solicitar a redefinição da senha neste momento.";
				this.loading = false;
				return;
			}
			this.loading = false;

			// Verifica se foi retornado
			if (result) {
				// Verifica o resultado da requisição
				if (result.error) {
					this.error_msg = result.data;
					return;
				} else {
					this.error_msg = "Solicitação enviada!";
					return;
				}
			} else {
				this.error_msg = "Não foi possível solicitar a redefinição da senha.";
				return;
			}
		},

		back: function() {
			this.$emit("back");
		},
	}
}
</script>

<style scoped>
.forgot-password-wrapper {
	width: 100vw;
	height: 100vh;
	background: #222;
}

.login-logo {
	height: 30px;
	margin: 15px auto;
	display: block;
	margin-bottom: 45px;
}

.forgot-password-button-wrapper {
    padding: 0px 0px 15px;
    width: 100%;
}

.forgot-password-button-wrapper > button {
    border: none;
    background: none;
    text-align: left;
	color: #fff;
	font-size: 16px;
}

.forgot-password-text-wrapper {
    width: 100%;
	text-align: center;
}

.forgot-password-text-wrapper > h3 {
	margin-bottom: 10px;
	color: #fff;
}

.forgot-password-logo {
	height: 30px;
	margin: 15px auto;
	display: block;
	margin-bottom: 25px;
}

.forgot-password-form	{
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	margin: auto;
	width: 400px;
	height: 395px;
	background: #333;
	padding: 25px;
	border-radius: 4px;
}

.forgot-password-button-wrapper,
.forgot-password-text-wrapper, 
.forgot-password-input-wrapper {
	position: relative;
	width: 100%;
}

.forgot-password-input {
	width: 100%;
	height: 40px;
	padding-left: 40px;
	border: none;
	margin-bottom: 25px;
	font-weight: bold;
	color: #222;
}

.forgot-password-input-icon {
	position: absolute;
	width: 40px;
	height: 40px;
	left: 0;
	line-height: 40px;
	color: #222;
}

.forgot-password-wrapper > a {
	font-size: 12px;
	text-decoration: none;
	color: #fff;
}

.forgot-password-error-wrapper {
	min-height: 38px;
	margin: 20px 0px;
	text-align: center;
}

.forgot-password-error-wrapper > .forgot-password-error {
	color: #fff;
	font-size: 14px;
	font-weight: bold;
}

.forgot-password-submit {
	width: 100%;
	height: 40px;
	border: none;
	background: #fff;
	font-weight: bold;
}

</style>